/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Author/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Author({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Notes/Content/Note/Author"
  
}) {
let noteDateValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'date',
})
let globalCurrentLocationTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.time_zone_id',
})
let aggregateData = fromHelpers.formatTimestamp(noteDateValueData, globalCurrentLocationTimeZoneIdValueData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let noteCreatorValueData = fromData.useDataFormat({ viewPath,
context: 'note',
path: 'creator',
format: fromHelpers.formatCreator,
})
let noteValueData = fromData.useDataFormat({ viewPath,
context: 'note',
format: fromHelpers.formatEditor,
})
let aggregateData1 = fromAggregate.join(noteCreatorValueData, noteValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceS}
 data="note.date"
 data="global.current_location.time_zone_id"
 aggregate="helpers.js formatTimestamp"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 data="note.creator"
 format="helpers.js formatCreator"
 data="note"
 format="helpers.js formatEditor"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData1}
/>
{children}
</React.Fragment>)
}